var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner-border text-light",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('h4',{staticClass:"sr-only"},[_vm._v("Cargando...")])]),_c('div',{staticClass:"mt-3 text-white font-weight-bold loading-text"},[_vm._v("Cargando...")])])])
}]

export { render, staticRenderFns }